// src/api/config.js
export const API_BASE_URL = 'https://apply.aapkiyojana.org/supers/';
